'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleActions;

var _isFunction = require('./isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _combineActions = require('./combineActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function reduceReducers() {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
}

function handleAction(types, reducer) {
  var splitTypes = types.split(_combineActions.ACTION_TYPE_DELIMITER);
  return function (state, action) {
    if (!splitTypes.includes(action.type)) {
      return state;
    }
    return (0, _isFunction2.default)(reducer) ? reducer(state, action) : state;
  };
}

function handleActions(handlers, defaultState) {
  var reducers = Object.getOwnPropertyNames(handlers).map(function (types) {
    return handleAction(types, handlers[types]);
  });
  var reducer = reduceReducers.apply(undefined, _toConsumableArray(reducers));
  return typeof defaultState !== 'undefined' ? function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    return reducer(state, action);
  } : reducer;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/flux-actions/static-1.35/js/handleActions.js
// module id = 320
// module chunks = 0